import styled, { css } from 'styled-components';
import DocsAlert from './DocsAlert';

const skinBackground = ({ skin }) => {
  switch (skin) {
    case 'success':
      return css`
        background-color: var(--success100);
      `;
    case 'warning':
      return css`
        background-color: var(--accent100);
      `;
    case 'error':
      return css`
        background-color: var(--error100);
      `;
    default:
      return css`
        background-color: var(--success100);
      `;
  }
};

export default styled(DocsAlert)`
  width: 100%;
  .docs-alert {
    ${skinBackground};
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    margin: 2rem 5rem;
    padding: 2rem 0;
    position: relative;
    text-align: center;

    &__close {
      position: absolute;
      right: 0;
      top: 0;

      svg {
        fill: var(--grey900);
      }
    }

    &__title {
      color: var(--grey900);
      font-size: 1.6rem;
      font-weight: 500;
      margin: 0 0 0.5rem;
    }

    &__type,
    &__message,
    &__carrier {
      color: var(--grey900);
      font-weight: 500;
    }

    &__message,
    &__carrier {
      text-transform: uppercase;
    }
  }
`;
